import {
  SAVE_WISHLIST,
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  REMOVE_ALL_FROM_WISHLIST
} from "../actions/wishlistActions";

const initState = [];
const saveWishList = (wishList) => {
  const credentials = {wishList, IDRef: localStorage.getItem("IDDetCliRef")};
  const body = JSON.stringify(credentials);
  //console.log(credentials);
  //console.log(body);

  var endpoint = global.endpoint + "/pegaso/updateWishList";
  fetch(endpoint, {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded", }),
    body: body,
    withCredentials: false,
  })
    .then((res) => res.json())
    .then(
      (result) => {

      }
    )
}

const wishlistReducer = (state = initState, action) => {
  const wishlistItems = state,
    product = action.payload;
  let _newState;
  switch (action.type) {


    case SAVE_WISHLIST:
      //saveWishList(_newState);
      return product;
    case ADD_TO_WISHLIST:
        const wishlistItem = wishlistItems.filter(
          item => item.id === product.id
        )[0];
        _newState = (wishlistItem === undefined) ? [...wishlistItems,  product] : wishlistItems;
        saveWishList(_newState);
        return _newState;
    case REMOVE_FROM_WISHLIST:
      const remainingItems = (wishlistItems, product) =>
        wishlistItems.filter(wishlistItem => wishlistItem.id !== product.id);
      _newState = remainingItems(wishlistItems, product);
      saveWishList(_newState);
      return _newState;
    case REMOVE_ALL_FROM_WISHLIST:
      return wishlistItems.filter(item => {
        return false;
      });

    default:
      return wishlistItems;
  }
};

export default wishlistReducer;
